import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '../utils/translations';
import { COLORS_AVISOS as colors } from '../utils/globals';

const Legend = props => {
    const { language } = props;

    return (
        <div
            className="legend"
            style={{
                display: '-webkit-flex',
                WebkitFlexDirection: 'column',
                WebkitFlexWrap: 'wrap',
            }}
        >
            <div>
                <div
                    className="legend__color"
                    style={{
                        backgroundColor: colors.sensePerill,
                    }}
                />
                {translate(language, 'avisos_level_0')}
            </div>
            <div>
                <div
                    className="legend__color"
                    style={{
                        backgroundColor: colors.perillModerat,
                    }}
                />
                {translate(language, 'avisos_level_1')}
            </div>
            <div>
                <div
                    className="legend__color"
                    style={{
                        backgroundColor: colors.perillAlt,
                    }}
                />
                {translate(language, 'avisos_level_2')}
            </div>
            <div>
                <div
                    className="legend__color"
                    style={{
                        backgroundColor: colors.perillMoltAlt,
                    }}
                />
                {translate(language, 'avisos_level_3')}
            </div>
        </div>
    );
};

Legend.propTypes = {
    language: PropTypes.string,
};

export default Legend;



// WEBPACK FOOTER //
// ./src/partials/Legend.js